import * as Preact from 'preact';
import * as H from 'preact/hooks';
import { AppError } from '../data/appError';
import { AppControlContext } from './context/appControl';
import { useDispatch } from './hooks/redux';
import * as CoreStore from '../store/core';
import { LoadingScreenError } from '@dora/components';
import { TranslateContext } from '@denysvuika/preact-translate';

export interface Props {
    error: AppError;
}
/** An error page for any app-wide errors */
export function Component({ error }: Props) {
    const appControl = H.useContext(AppControlContext);
    const dispatch = useDispatch();
    const { t } = H.useContext(TranslateContext);

    // clear error when error page is displayed
    H.useEffect(() => {
        appControl?.enhanceCloseApp('clear_load_error', () => {
            dispatch(CoreStore.clearError());
        });
    }, [appControl]);

    switch (error) {
        case AppError.LAYOUT_LOAD_FAILED:
            return (
                <LoadingScreenError.Component
                    onClose={() => appControl?.closeApp()}
                    heading={t('i18n.global.unknownErrorHeading')}
                    body={t('i18n.space.unknownErrorBody')}
                />
            );
        case AppError.CONFIGURATION_LOAD_FAILED:
        case AppError.CONFIGURATION_DATA_LOAD_FAILED:
            return (
                <LoadingScreenError.Component
                    onClose={() => appControl?.closeApp()}
                    heading={t('i18n.global.unknownErrorHeading')}
                    body={t('i18n.configuration.unknownErrorBody')}
                />
            );
        default:
            //  It shouldn't be possible to get here due to strict typing - but it's probably best
            //  to handle it anyway
            return (
                <LoadingScreenError.Component
                    onClose={() => appControl?.closeApp()}
                    heading={t('i18n.global.unknownErrorHeading')}
                    body={t('i18n.global.unknownErrorBody')}
                />
            );
    }
}
